<!-- Content No Data -->
<!-- Service Level widget shouldn't show no data and instead should just show the zero data -->
<!-- <app-module-error [noData]="true" *ngIf="noData && !moduleManager.showLoader"></app-module-error> -->

<app-module-error *ngIf="somethingWentWrong && !IsLoadingData"></app-module-error>

<!-- Content -->
<div class="gridItemChildModule w-100 h-100 d-flex" style="padding: 1rem 1rem; flex-direction: column">
    <!-- Chart -->
    <div class=" h-100" [hidden]="!dataLoadSuccess" style="width: 100%;">
        <canvas baseChart *ngIf="chartConfig"
            [type]="chartConfig.type"
            [legend]="chartConfig.options.plugins.legend"
            [datasets]="chartConfig.data.datasets"
            [labels]="chartConfig.data.labels"
            [options]="chartConfig.options"
            [plugins]="chartConfig.plugins">
        </canvas>
    </div>
</div>
